export const TRANSLATIONS = {
    clickToCall: 'click_to_call',
    receiveCallFromBuyers: 'receive_calls_from_buyers',
    accountMergingPostingFeedback: 'account_merging_posting_feedback',
    copiedToClipboard: 'copiedToClipboard',
    markAsSold: 'markAsSold',
    adExpirationRepublishButton: 'ad_expiration_republish_button',
    featureAdButton: 'featureAdButton',
    or: 'or',
    someoneFromOutside: 'someoneFromOutside',
    soldOutsideOlx: 'soldOutsideOlx',
    soldOutsideText: 'soldOutsideText',
    soldOutsideBtnLabel: 'soldOutsideBtnLabel',
    selectBuyer: 'selectBuyer',
    backButtonSI: 'backButtonSI'
};
export const noChatsFooter = {
    letgo: 'noChatsFooterLetgo',
    olx: 'noChatsFooter'
};

export const noChatsFooterBuying = {
    letgo: 'noChatsFooterBuyingLetgo',
    olx: 'noChatsFooterBuying'
};

export const noChatsText = {
    letgo: 'noChatsTextLetgo',
    olx: 'noChatsText'
};

export const noTransactionChatsText = {
    header: {
        id: 'noChatsTransactionText',
        defaultMessage: 'Haven’t talked to anyone yet?'
    },
    footer: {
        id: 'noChatsTransactionFooter',
        defaultMessage: 'Find a vehicle you like and start conversation!'
    },
    buttonText: {
        id: 'exploreButtonTitle',
        defaultMessage: 'Explore all cars'
    }
};

export const sellYourStuff = 'sellYourStuff';
export const browseListings = 'browseListings';
export const listingAdAutoboostadLabel = 'listing_ad_autoboostad_label';
export const listingAdFeaturedLabel = 'listing_ad_featured_label';
export const unfollowProfile = 'unfollowProfile';
export const followProfile = 'followProfile';
export const followers = 'followers';
export const following = 'following';

export const consentsTextsTitle = {
    title: 'consent_page_login_flow_title_letgo'
};

export const consentsTextsSubtitle = {
    letgo: 'consent_page_login_flow_subtitle_letgo',
    olx: 'consent_page_login_flow_subtitle'
};

export const signUpPrivacyTexts = {
    loginPrivacyDescLetgo: 'loginPrivacyDescLetgo',
    loginPrivacyDesc1: 'loginPrivacyDesc1',
    loginEnterPhone: 'login_enter_phone_privacy',
    loginEnterEmail: 'login_email_enter_phone_privacy'
};
export const TRANSLATIONS_PRIVATE_PROFILE = {
    USER_VERIFIED_WITH: 'userVerifiedWith',
    EDIT_PROFILE: 'editProfile',
    MY_ACCOUNT_VIEW_PROFILE: 'my_account_view_profile'
};

export const MESSAGES_PRIVATE_PROFILE = {
    EDIT_PROFILE: 'Edit profile'
};

export const BILLING_FORM_FIELDS = {
    REQUIRED_FIELD: 'requiredFields',
    INVALID_FORMAT: 'invalidFormat'
};

export const CHOOSE_PACKAGE = {
    VIEWS: 'views',
    DAYS_FEATURED: 'days_featured',
    BOOST_TO_TOP_VAL: 'boost_to_top_val',
    MY_ADS_MODERATION_BTN: 'my_ads_moderation_button_text',
    SELL_FASTER_HEADING: 'sell_faster_heading',
    SELL_FASTER: 'sell_faster',
    BUY_PKG_FA: 'buyPkgSeeExampleFaProposition',
    BUY_PKG_BTT: 'buyPkgSeeExampleBttProposition',
    BUY_PKG_SPOTLIGHT: 'buyPkgSeeExampleSpotlightProposition',
    PREVIEW_PACKAGE_TEXT: 'preview_package_text',
    SEE_FEATURED_AD: 'see_featured_ad',
    SEE_BOOST_TO_TOP: 'see_boost_to_top',
    SELL_MORE: 'sell_more',
    POST_MORE_ADS: 'post_more_ads',
    SHOW_ME_PACKAGES: 'show_me_packages',
    EXAMPLE_FA: 'example_FA',
    EXAMPLE_BTT: 'example_BTT',
    UNDERSTOOD: 'understood',
    FEATURED_AD: 'featured_ad',
    CHOOSEPKG_FA: 'choosePkg_FA',
    CHOOSEPKG_BTT: 'choosePkg_BTT',
    CHOOSEPKG_AUTOBOOST: 'choosePkg_AUTOBOOST',
    ATTRACT_MORE_BUYERS: 'attract_more_buyers',
    SUBHEADING_FA: 'subHeading_FA',
    SUBHEADING_BTT: 'subHeading_BTT',
    SUBHEADING_SPOTLIGHT: 'subHeading_SPOTLIGHT',
    PREVIEW: 'preview',
    SEE_EXAMPLE: 'see_example',
    FEATURED_MODAL_HEADER_FA: 'featured_modal_header_FA',
    FEATURED_MODAL_HEADER_BTT: 'featured_modal_header_BTT',
    HOW_IT_WORKS: 'how_it_works',
    AD_APPEARNCE_FA: 'ad_appearence_FA',
    AD_APPEARNCE_2_FA: 'ad_appearence_2_FA',
    AD_APPEARNCE_BTT: 'ad_appearence_BTT',
    AD_APPEARNCE_2_BTT: 'ad_appearence_2_BTT',
    BUY_PKG_SEE_EXAMPLE: 'buyPkgSeeExample',
    EXAMPLE_: 'example_',
    FEATURED_MODAL_HEADER: 'featured_modal_header_',
    AD_APPEARNCE_: 'ad_appearence_',
    AD_APPEARNCE_2_: 'ad_appearence_2_',
    CHOOSE_PKG: 'choosePkg_',
    BUY_PKG: 'buyPkg_',
    BUY_PKG_WHAT_NEXT: 'buyPkgWhatNext',
    PAY: 'Pay'
};

